import Timer from "@/components/timer/index.vue";
import Banner from "../banner/index.vue";
import Product from "@/modules/promotions/promotion-products/components/promotion-product/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "promotion-banners",
    components: { Timer, Banner, Product },
    data() {
        return {
            payload: { skip: 1 },
            slug: [],
        };
    },
    props: ["title", "description", "path", "startTime", "endTime"],
    computed: {
        ...mapGetters({
            getList: `promotions/getList`,
            getCurrentList: "promotions/getCurrentList",
            productLoading: "promotions/productLoading",
            getProductsLength: "promotions/getProductsLength",
            getLimit: "promotions/getLimit",
            list: "discountProducts/list",
            productLength: "discountProducts/productLength",
            skip: "discountProducts/skip",
            promotionSkip: "promotions/skip",
        }),

        getProducts() {
            let arr = [];
            for (let i in this.list) {
                if (this.list[i].slug === this.$route.params.promo) {
                    for (let j in this.list[i].products.data) {
                        arr.push(this.list[i].products.data[j]);
                    }
                }
            }
            return arr;
        },
        getTime() {
            for (let i in this.list) {
                if (this.$route.params.promo === this.list[i].slug) {
                    return this.list[i];
                }
            }
        },
    },
    created() {
        this.resetSkip();
        this.fetchPromoList();
        this.fetchAllProducts();

        // this.getDateActions()
    },
    watch: {
        $route() {
            this.resetSkip();
            this.fetchPromoList();
            this.fetchAllProducts();
        },
    },
    methods: {
        ...mapActions({
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            fetchNewPromoList: `promotions/GET_PROMOTIONS_CURRENT_LIST`,
            fetchAllProducts: `discountProducts/GET_PRODUCTS_LIST`,
        }),
        ...mapMutations({
            resetSkip: `promotions/RESET_SKIP`,
            resetLimit: `promotions/RESET_LIMIT`,
        }),
    },
};
